import { Outlet } from 'react-router-dom'
import SiteHeader from '@shared/components/SiteHeader'
import SiteFooter from '@shared/components/SiteFooter'
import ScrollToTop from '@shared/components/ScrollToTop'

export default function SiteLayout() {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <ScrollToTop />
            <SiteHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <SiteFooter flush />
        </div>
    )
}
